// extracted by mini-css-extract-plugin
module.exports = {"body":"body--vU5B9"};